import { createFileRoute } from '@tanstack/react-router';

import SitemapModal from '../../-components/SitemapModal';

export const Route = createFileRoute('/_authenticated/sitemaps/$tenantId/nodes/new')({
    component: SitemapModal,
});
